import { render, staticRenderFns } from "./ManageLiveAnswering.vue?vue&type=template&id=588abb7c"
import script from "./ManageLiveAnswering.vue?vue&type=script&lang=js"
export * from "./ManageLiveAnswering.vue?vue&type=script&lang=js"
import style0 from "./ManageLiveAnswering.vue?vue&type=style&index=0&id=588abb7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports